import { createContext, useContext, useEffect, useState } from "react";
import { TSize } from "../constants/types";

interface ImageViewerSplashContextProps {
    imgUrl : string;
    setImgUrl: Function;
    windowSize: TSize;
    setWindowSize: Function;
}

const ImageViewerSplashContext = createContext<ImageViewerSplashContextProps>({} as ImageViewerSplashContextProps);

export const useImageViewerSplashContext = () => {
  const context = useContext(ImageViewerSplashContext);
  if (context === undefined) {
    throw new Error("CustomContext must be used within a CustomContextProvider");
  }
  return context;
};

export const ImageViewerSplashContextProvider: React.FC = ({ children }) => {
    const [imgUrl, setImgUrl] = useState<string | undefined>(undefined);
    const [windowSize, setWindowSize] = useState<TSize>({x: window.innerWidth > 1232 ? 1232 : window.innerWidth, y: window.innerHeight});

    return (
        <ImageViewerSplashContext.Provider value={{imgUrl,
                                                   setImgUrl,
                                                   windowSize,
                                                   setWindowSize}}>
            {children}
        </ImageViewerSplashContext.Provider>
    );
};

export default ImageViewerSplashContext;